import { render, staticRenderFns } from "./TSGBrauchwasserPreview.vue?vue&type=template&id=96b53124&scoped=true&"
import script from "./TSGBrauchwasserPreview.vue?vue&type=script&lang=ts&"
export * from "./TSGBrauchwasserPreview.vue?vue&type=script&lang=ts&"
import style0 from "./TSGBrauchwasserPreview.vue?vue&type=style&index=0&id=96b53124&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96b53124",
  null
  
)

export default component.exports